const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
const arabicDigits = "٠١٢٣٤٥٦٧٨٩";

export const normalizePersianDigits = (value) => String(value ?? "")
  .replace(/[۰-۹]/g, (digit) => persianDigits.indexOf(digit))
  .replace(/[٠-٩]/g, (digit) => arabicDigits.indexOf(digit));

export const parsePersianNumber = (value) => {
  const normalized = normalizePersianDigits(value)
    .replace(/[٬،,\s]/g, "")
    .trim();
  if (!normalized || !/^\d+$/.test(normalized)) return null;
  const parsed = Number(normalized);
  return Number.isSafeInteger(parsed) ? parsed : null;
};

export const formatPersianNumber = (value) => new Intl.NumberFormat("fa-IR").format(value ?? 0);
